import React, { useEffect, useRef, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { startSso } from '@api/sso';
import { RETURN_TO_PARAM, rememberReturnTo, savePendingSsoState } from '@utils/ssoSession';
import SsoStatus from './SsoStatus';

const SsoStart: React.FC = () => {
  const { provider = '' } = useParams();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState<string | null>(null);
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    rememberReturnTo(searchParams.get(RETURN_TO_PARAM));
    startSso(provider)
      .then(({ authorizeUrl, state }) => {
        savePendingSsoState(state);
        globalThis.location.assign(authorizeUrl);
      })
      .catch((err: unknown) => {
        setError(err instanceof Error ? err.message : 'Single sign-on could not be started');
      });
  }, [provider, searchParams]);

  return (
    <SsoStatus
      title="Single sign-on"
      subtitle="Redirecting you to your organization's sign-in page..."
      error={error}
    />
  );
};

export default SsoStart;
